/* Copyright IBM Corp. 2017 */
import { Injectable } from '@angular/core';

import { WchService } from '../wch.service';
import { li } from './../logger/logger.service';

const LOGGER = 'RefreshService';

/*
 * Implementation of a service that allows to refresh pending requests
 */
@Injectable({ providedIn: 'root' })
export class RefreshService {

    /*
     * Refreshes the rendering context and all JSON data that is currently displayed
    */
    refresh: () => void;

    constructor(aWchService: WchService) {

        function _refresh(): void {
            // log
            li(LOGGER, 'refresh');
            // trigger
            aWchService.triggerRefresh();
        }

        // attach
        this.refresh = _refresh;
    }
}
